import React, { useEffect, useState } from "react";

const CustomTimeSelector = (props) => {
    const {
      format = "24-hour",
      name,
      value,
      disabledField,
      error,
      title,
      timeSlotStart = "NA",
      minTime = "00:00",
      maxTime = "23:59",
    } = props;
  const isTimeInRange = (time, min, max) => {
    const toMinutes = (t) => {
      const [h, m] = t.split(":").map(Number);
      return h * 60 + m;
    };
    return (
      toMinutes(time) >= toMinutes(min) && toMinutes(time) <= toMinutes(max)
    );
  };

  const generateTimeOptions = () => {
    const options = [];
    const is24HourFormat = format === "24-hour";
    let [startHour, startMinute] = minTime.split(":").map(Number);

    while (true) {
      const hourString = is24HourFormat
        ? startHour.toString().padStart(2, "0")
        : (startHour % 12 || 12).toString().padStart(2, "0");
      const minuteString = startMinute.toString().padStart(2, "0");
      const meridian = !is24HourFormat ? (startHour < 12 ? "AM" : "PM") : "";

      const rawTime = `${startHour
        .toString()
        .padStart(2, "0")}:${minuteString}`;
      const displayTime = is24HourFormat
        ? rawTime
        : `${hourString}:${minuteString} ${meridian}`;

      if (isTimeInRange(rawTime, minTime, maxTime)) {
        options.push(displayTime);
      }

      startMinute += 15;
      if (startMinute >= 60) {
        startMinute = 0;
        startHour += 1;
      }

      if (
        startHour > maxTime.split(":")[0] ||
        (startHour === maxTime.split(":")[0] &&
          startMinute > maxTime.split(":")[1])
      ) {
        break;
      }
    }

    return options;
  };



  return (
      <select value={value} name={name}
       className={error ? "customSelect customError" : "customSelect"}
        onBlur={(data) => props.handleErrors(data.target.name)}
        onChange={(data) => {
             props.onChange(data.target.value, data.target.name)}
        }
        disabled={disabledField ? disabledField : false}
       >
        <option value="">Select {title}</option>
        {generateTimeOptions().map((time, index) => (
          <option key={index} value={time}>
            {time}
          </option>
        ))}
      </select>
  );
};

export default CustomTimeSelector;
